/* =========================================================================
   em-home.js — Bewegung auf der Startseite (012-startseite-ahead).

   1. Hero: das Bild wandert beim Scrollen langsamer als die Seite.
   2. Adventskalender: Tage bis zum 1. Tuerchen, nur aus dem Datum gerechnet.

   Das Skript wird von jeder em-home-Section eingebunden und laeuft trotzdem
   nur einmal (Waechter unten). Ohne Skript fehlt nur die Bewegung und der
   Zaehler bleibt versteckt — die Seite ist vollstaendig.
   ========================================================================= */
(function () {
  "use strict";
  if (window.__emHome) return;
  window.__emHome = true;

  var ruhig = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------------------------------------------------------- Hero-Tiefe */
  function hero() {
    if (ruhig) return;
    var media = document.querySelector(".em-hero__media");
    if (!media) return;
    var img = media.querySelector("img, svg");
    if (!img) return;
    var laeuft = false;
    function zeichnen() {
      laeuft = false;
      if (window.innerWidth < 750) { img.style.removeProperty("--em-para"); return; }
      var r = media.getBoundingClientRect();
      if (r.bottom < 0) return;
      img.style.setProperty("--em-para", Math.round(-r.top * 0.18) + "px");
    }
    function anstossen() {
      if (laeuft) return;
      laeuft = true;
      window.requestAnimationFrame(zeichnen);
    }
    zeichnen();
    window.addEventListener("scroll", anstossen, { passive: true });
    window.addEventListener("resize", anstossen, { passive: true });
  }

  /* ------------------------------------------------- Tage bis zum Tuerchen */
  function zaehler() {
    var els = document.querySelectorAll("[data-em-count]");
    if (!els.length) return;
    var jetzt = new Date();
    var heute = new Date(jetzt.getFullYear(), jetzt.getMonth(), jetzt.getDate());
    var start = new Date(heute.getFullYear(), 11, 1);
    var ende  = new Date(heute.getFullYear(), 11, 24);
    if (heute > ende) start = new Date(heute.getFullYear() + 1, 11, 1);

    var n, t;
    if (heute >= start && heute <= ende) {
      n = heute.getDate();
      t = n === 1 ? "Heute geht das erste Türchen auf" : "Heute ist Türchen " + n + " dran";
    } else {
      n = Math.round((start - heute) / 86400000);
      t = n === 1 ? "Tag bis zum ersten Türchen" : "Tage bis zum ersten Türchen";
    }
    Array.prototype.forEach.call(els, function (el) {
      var zahl = el.querySelector("[data-em-count-n]");
      var text = el.querySelector("[data-em-count-t]");
      if (zahl) zahl.textContent = n;
      if (text) text.textContent = t;
      el.hidden = false;
    });
  }

  function start() { hero(); zaehler(); }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
  document.addEventListener("shopify:section:load", zaehler);
})();

/* ---------------------------------------------------------------------
   012, Runde 9: Scroll-Fortschritt fuer [data-em-scroll] (0 bis 1, waehrend
   das Element durchs Bild wandert) und Einblendung fuer Zuckerwaage und
   Zutatenliste. Alles ueber rAF und IntersectionObserver, nichts im
   Scroll-Ereignis selbst.
   ------------------------------------------------------------------- */
(function () {
  "use strict";
  if (window.__emHome2) return; window.__emHome2 = true;
  var ruhig = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function fortschritt() {
    var els = document.querySelectorAll("[data-em-scroll]");
    if (!els.length) return;
    if (ruhig) { Array.prototype.forEach.call(els, function (el) { el.style.setProperty("--p", "0.7"); }); return; }
    var laeuft = false;
    function zeichnen() {
      laeuft = false;
      var vh = window.innerHeight;
      for (var i = 0; i < els.length; i++) {
        var r = els[i].getBoundingClientRect();
        if (r.bottom < -200 || r.top > vh + 200) continue;
        /* 0 wenn die Oberkante unten hereinkommt, 1 wenn die Mitte im oberen Drittel steht */
        var p = (vh * 0.9 - r.top) / (vh * 0.9 - vh * 0.25 + r.height * 0.5);
        p = Math.max(0, Math.min(1, p));
        els[i].style.setProperty("--p", p.toFixed(3));
      }
    }
    function anstossen() { if (laeuft) return; laeuft = true; window.requestAnimationFrame(zeichnen); }
    zeichnen();
    window.addEventListener("scroll", anstossen, { passive: true });
    window.addEventListener("resize", anstossen, { passive: true });
  }

  function einblenden() {
    var ziele = document.querySelectorAll("[data-em-zucker], [data-em-streich]");
    if (!ziele.length) return;
    if (ruhig || !("IntersectionObserver" in window)) { Array.prototype.forEach.call(ziele, function (z) { z.classList.add("is-in"); }); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add("is-in"); io.unobserve(e.target); } });
    }, { threshold: 0.35 });
    Array.prototype.forEach.call(ziele, function (z) { io.observe(z); });
  }

  function start() { fortschritt(); einblenden(); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start); else start();
})();
